import { create } from 'zustand';
import commonMiddlewares from './middlewares';

import getOrganization from '../api/getOrganization';

export const useOrganizationStore = create(
	commonMiddlewares(set => ({
		masterOrg: null,
		organizationTimezone: null,
		orgLoading: false,
		orgLoaded: false,

		setMasterOrg: org => set(() => ({ masterOrg: org }), false, 'organization/setMasterOrg'),
		setOrganizationTimezone: timezone =>
			set(() => ({ organizationTimezone: timezone }), false, 'organization/setOrganizationTimezone'),

		fetchOrganization: async ({ __config, internalManagingOrganizationID }) => {
			try {
				set(() => ({ orgLoading: true }), false, 'organization/fetchBookmarks');
				const organization = await getOrganization({
					__config,
					internalManagingOrganizationID,
				});

				const timeZoneExtension = organization?.extension?.find(
					el => el.url === 'http://www.ramsoft.com/fhir/StructureDefinition/timezoneIANA'
				);

				set(
					() => ({
						masterOrg: organization,
						organizationTimezone: timeZoneExtension?.valueString || '',
						orgLoading: false,
						orgLoaded: true,
					}),
					false,
					'organization/fetchOrganization'
				);
			} catch (err) {
				console.error(err);
				throw err;
			}
		},

		resetOrganizationStore: () =>
			set({
				masterOrg: null,
				organizationTimezone: null,
				orgLoading: false,
				orgLoaded: false,
			}),
	}))
);
